import rightArrowIcon from '@SvgIcon/arrow-right-c.svg'
import closeIcon from '@SvgIcon/close-circled.svg'

import { v1 as uuidv1 } from 'uuid'
import svgIconHtml from '../../../shared/svgIconHtml'
import eventBus from '../../eventBus'
import store, { MAX_PRODUCTS } from './store'

export default {
  name: 'OverviewWidget',

  // language=HTML
  template: `
    <div
      class="product-comparison-overview-widget"
      :class="{ 'is-visible': Object.keys(products).length }"
    >
      <div class="product-comparison-overview-widget__heading">
        <span>Compare:</span>
      </div>
      <div
        v-for="(slot, idx) in productSlots"
        :key="slot.uuid"
        class="product-comparison-overview-widget__product"
        :title="!slot.empty ? slot.product.name : null">
        <template v-if="!slot.empty">
          <img :src="slot.product.thumb || '/images/placeholder.png'" alt="">
          <button
            type="button"
            class="product-comparison-overview-widget__remove-product"
            title="Remove product from comparison"
            @click="removeProduct(slot.product.id)"
          >${svgIconHtml(closeIcon)}
          </button>
        </template>
      </div>
      <a
        v-if="productIds.length > 1 && comparisonUrl"
        class="product-comparison-overview-widget__compare-button"
        :href="comparisonUrl"
        aria-label="Compare"
      >
        <span class="caption">Compare</span>
        ${svgIconHtml(rightArrowIcon)}
      </a>
      <span
        v-else
        class="product-comparison-overview-widget__instructions"
      >
        Add 1 more to compare.
      </span>
    </div>
  `,

  computed: {
    productIds() {
      return store.state.productIds
    },

    products() {
      return store.state.products
    },

    comparisonUrl() {
      return store.state.comparisonUrl
    },

    productSlots() {
      const slots = []
      for (let i = 0; i < MAX_PRODUCTS; i += 1) {
        const productId = this.productIds[i] || null
        const product = this.products[productId] || null
        if (!product) {
          slots.push({
            uuid: uuidv1(),
            empty: true,
          })
        } else {
          slots.push({
            uuid: uuidv1(),
            empty: false,
            product,
          })
        }
      }
      return slots
    },
  },

  methods: {
    removeProduct(id) {
      eventBus.$emit('remove-product-from-comparison', id)
    },
  },
}
